import { styled } from 'styled-components';

import { LinkSection, LinkTextColor } from 'ui/components/LinkSection';

interface NavigationRowProps {
  label: string;
  color?: LinkTextColor;
  href?: string;
  onClick?: () => void;
  target?: string;
  role?: string;
}

// only navigationRow has hover
const Navigation = styled(LinkSection)(
  ({ theme }) => `
  padding: 14px 16px;
  cursor: pointer;
  height: 47px;
  border-bottom: 1px solid ${theme.colors.grayMedium};

  &:hover {
    background-color: ${theme.colors.grayMedium};
  }

  &:last-child {
    border-bottom: none;
  }
  
  &:focus-visible {
    outline: 3px solid ${theme.colors.focusOutline};
  }

  &:first-child:hover {
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
  }

  &:last-child:hover {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }
`,
);

export const NavigationRow = ({ label, color = 'blueLight', ...restProps }: NavigationRowProps) => (
  <Navigation {...restProps} aria-label={label} color={color}>
    {label}
  </Navigation>
);
